import { useState } from "react";
import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { AppLayout } from "../../components/layout/app-layout";
import AnalysisTab from "./tabs/analysis.tab";
import SurveysTab from "./tabs/surveys.tab";
import AgentTemplatesTab from "./tabs/agent-templates.tab";
import GenerateSurveyTab from "./tabs/generate-survey.tab";

const Dashboard = () => {
  useSetPageTitle('Dashboard');
  const [activeTab, setActiveTab] = useState('surveys');

  const dashboardTabs = [
    { id: 'surveys', label: 'Surveys' },
    { id: 'analytics', label: 'Analytics' },
    { id: 'templates', label: 'Templates' },
    { id: 'generate-survey', label: 'Generate Survey' },
  ];

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/dashboard"
      navbarProps={{
        tabs: dashboardTabs,
        activeTab: activeTab,
        onTabChange: setActiveTab,
      }}
    >
      <div className="space-y-6">
        {activeTab === 'surveys' && (
          <SurveysTab />
        )}
        {activeTab === 'analytics' && (
          <AnalysisTab />
        )}
        {activeTab === 'templates' && (
          <AgentTemplatesTab />
        )}
        {activeTab === 'generate-survey' && (
          <GenerateSurveyTab />
        )}
      </div>
    </AppLayout>
  );
};

export default Dashboard;
